<template>
  <tr :class="{ 'access-parent-row': isParent, [`theme-${this.$theme.name}`]: isParent} ">
    <td :style="!isParent ? { paddingLeft: `${level * 24}px` } : {}">{{ permission.name }}</td>
    <td class="has-text-centered">
      <div class="pretty p-icon p-curve p-smooth p-bigger m-0">
        <input type="checkbox"
          :checked="hasChildren ? isAllChecked('isBlock') : permission.isBlock"
          @change="$emit('toggle', { permission: permission, type: 'isBlock', checked: $event.target.checked })">
        <div class="state p-primary">
          <span class="icon mso">
            check
          </span>
          <label />
        </div>
      </div>
    </td>
    <td class="has-text-centered">
      <div class="pretty p-icon p-curve p-smooth p-bigger m-0">
        <input type="checkbox"
          :checked="hasChildren ? isAllChecked('isRead') : permission.isRead"
          @change="$emit('toggle', { permission: permission, type: 'isRead', checked: $event.target.checked })"
          :disabled="permission.isBlock">
        <div class="state p-primary">
          <span class="icon mso">
            check
          </span>
          <label />
        </div>
      </div>
    </td>
    <td class="has-text-centered">
      <div class="pretty p-icon p-curve p-smooth p-bigger m-0">
        <input type="checkbox"
          :checked="hasChildren ? isAllChecked('isAdd') : permission.isAdd"
          @change="$emit('toggle', { permission: permission, type: 'isAdd', checked: $event.target.checked })"
          :disabled="permission.isBlock">
        <div class="state p-primary">
          <span class="icon mso">
            check
          </span>
          <label />
        </div>
      </div>
    </td>
    <td class="has-text-centered">
      <div class="pretty p-icon p-curve p-smooth p-bigger m-0">
        <input type="checkbox"
          :checked="hasChildren ? isAllChecked('isEdit') : permission.isEdit"
          @change="$emit('toggle', { permission: permission, type: 'isEdit', checked: $event.target.checked })"
          :disabled="permission.isBlock">
        <div class="state p-primary">
          <span class="icon mso">
            check
          </span>
          <label />
        </div>
      </div>
    </td>
    <td class="has-text-centered">
      <div class="pretty p-icon p-curve p-smooth p-bigger m-0">
        <input type="checkbox"
          :checked="hasChildren ? isAllChecked('isDelete') : permission.isDelete"
          @change="$emit('toggle', { permission: permission, type: 'isDelete', checked: $event.target.checked })"
          :disabled="permission.isBlock">
        <div class="state p-primary">
          <span class="icon mso">
            check
          </span>
          <label />
        </div>
      </div>
    </td>
    <td class="has-text-centered">
      <div class="pretty p-icon p-curve p-smooth p-bigger m-0">
        <input type="checkbox"
          :checked="hasChildren ? isAllChecked('isPrint') : permission.isPrint"
          @change="$emit('toggle', { permission: permission, type: 'isPrint', checked: $event.target.checked })"
          :disabled="permission.isBlock">
        <div class="state p-primary">
          <span class="icon mso">
            check
          </span>
          <label />
        </div>
      </div>
    </td>
  </tr>
</template>

<script>
export default {
  name: 'PermissionRow',
  props: {
    permission: Object,
    allPermissions: Array,
    level: { type: Number, default: 0 }
  },
  computed: {
    children() {
      return this.allPermissions.filter((p) => p.parentId === this.permission.permissionRecordID)
    },
    hasChildren() {
      return this.children.length > 0
    },
    isParent() {
      return this.level === 0
    }
  },
  methods: {
    isAllChecked(type) {
      return this.children.length > 0 && this.children.every((child) => child[type])
    },
    onToggle(type, checked) {
      // Update the parent's own permission property
      this.permission[type] = checked

      if (this.hasChildren) {
        this.children.forEach((child) => {
          child[type] = checked
          if (type === 'isBlock' && checked) {
            child.isRead = false
            child.isAdd = false
            child.isEdit = false
            child.isDelete = false
            child.isPrint = false
          }
        })
        this.$emit('toggle-all', this.permission.permissionRecordID, type, checked)
      } else {
        // This part is for child rows and is already correct
        // this.permission[type] = checked
        if (type === 'isBlock' && checked) {
          this.permission.isRead = false
          this.permission.isAdd = false
          this.permission.isEdit = false
          this.permission.isDelete = false
          this.permission.isPrint = false
        }
      }
    }
  }
}
</script>